import styled from '@emotion/styled';
import { css } from '@emotion/react/macro';

import { MEDIA_QUERIES, MAX_DESKTOP_WIDTH } from '../constants';

const getBackgroundStyles = ({ background }) => {
  if (!background) {
    return null;
  }
  const { backgroundColor } = background;
  let style = {
    ...(backgroundColor
      ? {
          backgroundColor,
        }
      : {
          backgroundColor: '#f4f5f7',
        }),
  };
  if (background.backgroundImages) {
    style = background.backgroundImages.reduce((acc, { width, url }) => {
      acc[`@media only screen and (min-width: ${width}px)`] = {
        backgroundImage: `url(${url})`,
        backgroundPosition: '50%',
        backgroundSize: 'cover',
      };
      return acc;
    }, style);
  }

  return css(style);
};

export const App = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  overflow: hidden;

  .ReactModal__Overlay & {
    opacity: 0;
    transition: opacity 400ms ease-in-out;
  }

  .ReactModal__Overlay--after-open & {
    opacity: 1;
  }

  .ReactModal__Overlay--before-close & {
    opacity: 0;
  }

  ${getBackgroundStyles};
`;

export const ScreenCenter = styled.div`
  display: flex;
  flex-direction: column;

  ${MEDIA_QUERIES[0]} {
    width: 100%;
  }
  ${MEDIA_QUERIES[1]} {
    max-width: ${MAX_DESKTOP_WIDTH};
    width: 100%;
    box-shadow: 0 0 20px rgb(0 0 0 / 30%);
  }
`;

export const FixedBotomLeft = styled.div`
  ${MEDIA_QUERIES[0]} {
    display: none;
  }
  position: fixed;
  bottom: 0;
  left: 0;
`;
export const FixedBotomRight = styled.div`
  ${MEDIA_QUERIES[0]} {
    display: none;
  }
  position: fixed;
  bottom: 0;
  right: 0;
`;

export const LoginContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const LoginButton = styled.button`
  background: #fff;
  color: rgba(0, 0, 0, 0.54);
  box-shadow: rgb(0 0 0 / 30%) 2px 2px 5px 0;
  border-color: transparent;
  text-align: center;
  border-radius: 3px;
  width: 300px;
  height: 40px;
  padding-top: 0;
  margin-bottom: 12px;
  font-size: 20px;
`;
